var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCreativeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "55px",
    viewBox: "0 0 60 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3B35186-568D-4F03-8A55-E642F39BE77F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Customzie-templete_01",
    transform: "translate(-1035.000000, -264.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(130.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(885.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-(6)",
    transform: "translate(20.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6825,9.8175 C43.4025,3.82 36.9725,3.33066907e-15 30,3.33066907e-15 C21.1375,3.33066907e-15 13.4525,6.1625 11.51,14.5725 C5.05,15.2525 0,20.68 0,27.25 C0,34.28 5.78,40 12.88,40 L44.6725,40 C53.125,40 60,33.195 60,24.8325 C60,17.1675 54.2325,10.77 46.6825,9.8175 Z",
    id: "Path",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.125,55 L26.875,55 C25.1525,55 23.75,53.5975 23.75,51.875 L23.75,41.25 L18.125,41.25 C17.375,41.25 16.6975,40.8025 16.4025,40.115 C16.1075,39.4275 16.25,38.6275 16.7675,38.0825 L28.6425,25.5825 C29.35,24.8375 30.655,24.8375 31.3625,25.5825 L43.2375,38.0825 C43.7525,38.625 43.8975,39.425 43.6025,40.115 C43.3075,40.8025 42.6275,41.25 41.88,41.25 L36.25,41.25 L36.25,51.875 C36.25,53.5975 34.8475,55 33.125,55 L33.125,55 Z",
    id: "Path",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,3.33066907e-15 C21.1375,3.33066907e-15 13.4525,6.1625 11.51,14.5725 C5.05,15.2525 3.33066907e-15,20.68 3.33066907e-15,27.25 C3.33066907e-15,34.28 5.78,40 12.88,40 L16.355,40 C16.1225,39.34 16.2775,38.5975 16.7625,38.0825 L28.6375,25.5825 C28.9925,25.21 29.495,25.025 29.9975,25.025 L29.9975,3.33066907e-15 L30,3.33066907e-15 Z",
    id: "Path",
    fill: "#00A4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,25.025 C29.4975,25.025 28.995,25.21 28.64,25.5825 L16.765,38.0825 C16.2775,38.5975 16.1225,39.34 16.3575,40 C16.37,40.0375 16.385,40.0775 16.4025,40.115 C16.6975,40.8025 17.375,41.25 18.125,41.25 L23.75,41.25 L23.75,51.875 C23.75,53.5975 25.1525,55 26.875,55 L30,55 L30,25.025 Z",
    id: "Path",
    fill: "#546D79"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCreativeIcon);
export default __webpack_public_path__ + "static/media/UploadCreativeIcon.adf4259b3739c64dedab6ce0bda85d27.svg";
export { ForwardRef as ReactComponent };